import { useRef, useEffect, useState } from 'react'
import SignaturePadLib from 'signature_pad'
import Button from '../common/Button'

export default function SignaturePad({ onSave, onCancel, initialData = null }) {
  const canvasRef = useRef(null)
  const signaturePadRef = useRef(null)
  const [isEmpty, setIsEmpty] = useState(true)

  useEffect(() => {
    const canvas = canvasRef.current
    const ratio = Math.max(window.devicePixelRatio || 1, 1)
    
    // Set canvas size
    canvas.width = canvas.offsetWidth * ratio
    canvas.height = canvas.offsetHeight * ratio
    canvas.getContext('2d').scale(ratio, ratio)

    // Initialize signature pad
    signaturePadRef.current = new SignaturePadLib(canvas, {
        backgroundColor: 'rgb(255, 255, 255)',
        penColor: 'rgb(0, 0, 255)',
        minWidth: 1.5,
        maxWidth: 3.5,
    })

    // Load initial data if provided
    if (initialData) {
      signaturePadRef.current.fromDataURL(initialData)
      setIsEmpty(false)
    }

    // Update isEmpty state on stroke
    signaturePadRef.current.addEventListener('endStroke', () => {
      setIsEmpty(signaturePadRef.current.isEmpty())
    })

    // Handle resize
    const handleResize = () => {
      const data = signaturePadRef.current.toDataURL()
      canvas.width = canvas.offsetWidth * ratio
      canvas.height = canvas.offsetHeight * ratio
      canvas.getContext('2d').scale(ratio, ratio)
      signaturePadRef.current.fromDataURL(data)
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [initialData])

  const handleClear = () => {
    signaturePadRef.current.clear()
    setIsEmpty(true)
  }

  const handleSave = () => {
    if (signaturePadRef.current.isEmpty()) {
      return
    }
    const dataUrl = signaturePadRef.current.toDataURL('image/png')
    onSave(dataUrl)
  }

  return (
    <div>
      <div className="border-2 border-gray-300 rounded-lg overflow-hidden mb-4">
        <canvas
          ref={canvasRef}
          className="w-full h-48 touch-none cursor-crosshair"
          style={{ touchAction: 'none' }}
        />
      </div>
      
      <p className="text-sm text-gray-500 text-center mb-4">
        Sign above using your finger or mouse
      </p>

      <div className="flex gap-3">
        <Button variant="secondary" onClick={handleClear}>
          Clear
        </Button>
        <Button variant="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button onClick={handleSave} disabled={isEmpty} className="ml-auto">
          Save Signature
        </Button>
      </div>
    </div>
  )
}
